"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestSessionDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const guest_session_json_1 = require("./guest-session-json");
exports.GuestSessionDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('GuestSession', guest_session_json_1.GuestSessionJsonMapper);
